import React from "react";
import { Button, getIcon } from "@dishopsaas/design-system";
import { Box, useTheme, Typography } from "@mui/material";
import { infoBarDesktopStyles } from "../InfoBar.styles";
import { ButtonProps } from "../../../1_types/InfoBarTypes";
import { DARK, TERTIARY, TRANSPARENT } from "../../../constants";

export const OrderTypeActions: React.FC<ButtonProps> = ({
  orderTypeLabel,
  orderTypeIcon,
  addressLabel,
  onClick,
}) => {
  const theme = useTheme();
  const styles = infoBarDesktopStyles(theme);
  const iconsStyle = { width: 22, height: 22 };

  return (
    <>
      <Button
        label={orderTypeLabel}
        leftIcon={orderTypeIcon}
        colorType={theme.palette.mode === DARK ? TRANSPARENT : TERTIARY}
        size="medium"
        borderRadius={32}
        RightIcon
        withoutHover
        height={40}
        onClick={onClick}
        iconStyle={iconsStyle}
      />
      <Box sx={styles.addressBlock} onClick={onClick}>
        {getIcon("position", { size: 18 })}
        <Typography variant="body1" sx={styles.typo}>
          {addressLabel}
        </Typography>
      </Box>
    </>
  );
};
